import { stringifyUrl } from 'query-string';
import { useFetch } from './use-fetch';
import { useQueryString } from './use-query-string';

export function useProductListing({
  endpoint,
  pageQueryString,
  sortByQueryString,
  itemsPerPageQueryString
}) {
  const [page, setPage] = useQueryString(pageQueryString);
  const [sortBy, setSortBy] = useQueryString(sortByQueryString);
  const [itemsPerPage, setItemsPerPage] = useQueryString(
    itemsPerPageQueryString
  );
  const stringifiedUrl = stringifyUrl({
    url: endpoint,
    query: {
      ...(page && { [pageQueryString]: page }),
      ...(sortBy && { [sortByQueryString]: sortBy }),
      ...(itemsPerPage && { [itemsPerPageQueryString]: itemsPerPage })
    }
  });
  const { data, error, isLoading } = useFetch(stringifiedUrl);

  return {
    data,
    error,
    isLoading,
    page,
    setPage,
    sortBy,
    setSortBy,
    itemsPerPage,
    setItemsPerPage
  };
}
